import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProfileReferAndEarn.css';

interface Referral {
  id: string;
  name: string;
  email: string;
  date: string;
  avatar?: string;
}

interface StatCardProps {
  value: string;
  label: string;
}

const ProfileReferAndEarn: React.FC = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const referralLink = 'https://www.coinsher.com/signup?ref=COINSHERTO3R41C9IZI4';
  const referralCode = 'COINSHERTO3R41C9IZI4';
  const totalReferrals = 3;
  const successfulReferrals = 3;

  const referrals: Referral[] = [
    {
      id: '1',
      name: 'Mustapha',
      email: 'mustaphahabib6954@gmail.com',
      date: '07/04/2025 10:48 PM'
    },
    {
      id: '2',
      name: 'Isaimail',
      email: 'isaismail048@gmail.com',
      date: '10/03/2025 7:17 PM'
    },
    {
      id: '3',
      name: 'Silas Ojole Christian',
      email: 'ojolesilas@gmail.com',
      date: '10/09/2025 9:06 PM'
    }
  ];

  const handleCopyLink = () => {
    navigator.clipboard.writeText(referralLink);
    console.log('Referral link copied!');
  };

  const handleCopyCode = () => {
    navigator.clipboard.writeText(referralCode);
    console.log('Referral code copied!');
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: 'Join Coinsher',
        text: `Use my referral code: ${referralCode}`,
        url: referralLink
      }).catch((error) => console.log('Error sharing:', error));
    } else {
      handleCopyLink();
    }
  };

  const handleActivityHistory = () => {
    console.log('Navigate to activity history');
  };

  const filteredReferrals = referrals.filter(referral =>
    referral.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    referral.email.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const StatCard: React.FC<StatCardProps> = ({ value, label }) => (
    <div className="refer-earn-stat-card">
      <div className="refer-earn-stat-value">{value}</div>
      <div className="refer-earn-stat-label">{label}</div>
    </div>
  );

  return (
    <div className="refer-earn-container">
      <div className="refer-earn-header">
        <button 
          className="refer-earn-back-button" 
          onClick={() => navigate('/profile')}
          aria-label="Go back"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <button 
          className="refer-earn-activity-button"
          onClick={handleActivityHistory}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8 4V8L10.5 9.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>Activity history</span>
        </button>
      </div>

      <div className="refer-earn-content">
        <div className="refer-earn-hero">
          <div className="refer-earn-hero-header">
            <h1 className="refer-earn-title">Refer and earn 💰</h1>
            <div className="refer-earn-money-icon">
              <svg width="23" height="23" viewBox="0 0 23 23" fill="none">
                <circle cx="11.5" cy="11.5" r="10" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M11.5 6V17M11.5 6C10.1193 6 9 7.11929 9 8.5C9 9.88071 10.1193 11 11.5 11M11.5 6C12.8807 6 14 7.11929 14 8.5C14 9.88071 12.8807 11 11.5 11M11.5 17C10.1193 17 9 15.8807 9 14.5C9 13.1193 10.1193 12 11.5 12M11.5 17C12.8807 17 14 15.8807 14 14.5C14 13.1193 12.8807 12 11.5 12M11.5 11V12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </div>
          </div>
          <p className="refer-earn-description">
            Share your referral code and earn when someone signs up using your link or code.
          </p>

          <div className="refer-earn-card">
            <div className="refer-earn-card-header">
              <span className="refer-earn-card-label">Referral link:</span>
              <div className="refer-earn-card-actions">
                <button 
                  className="refer-earn-icon-button"
                  onClick={handleShare}
                  aria-label="Share link"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M12 5.33333C13.1046 5.33333 14 4.43791 14 3.33333C14 2.22876 13.1046 1.33333 12 1.33333C10.8954 1.33333 10 2.22876 10 3.33333C10 4.43791 10.8954 5.33333 12 5.33333Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M4 10C5.10457 10 6 9.10457 6 8C6 6.89543 5.10457 6 4 6C2.89543 6 2 6.89543 2 8C2 9.10457 2.89543 10 4 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 14.6667C13.1046 14.6667 14 13.7712 14 12.6667C14 11.5621 13.1046 10.6667 12 10.6667C10.8954 10.6667 10 11.5621 10 12.6667C10 13.7712 10.8954 14.6667 12 14.6667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M5.72656 8.94L10.2799 11.7267" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10.2732 4.27333L5.72656 7.06" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <button 
                  className="refer-earn-copy-button"
                  onClick={handleCopyLink}
                >
                  Copy
                </button>
              </div>
            </div>
            <div className="refer-earn-card-value">
              {referralLink}
            </div>
          </div>

          <div className="refer-earn-card">
            <div className="refer-earn-card-header">
              <span className="refer-earn-card-label">Referral code:</span>
              <div className="refer-earn-card-actions">
                <button 
                  className="refer-earn-icon-button"
                  onClick={handleShare}
                  aria-label="Share code"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M12 5.33333C13.1046 5.33333 14 4.43791 14 3.33333C14 2.22876 13.1046 1.33333 12 1.33333C10.8954 1.33333 10 2.22876 10 3.33333C10 4.43791 10.8954 5.33333 12 5.33333Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M4 10C5.10457 10 6 9.10457 6 8C6 6.89543 5.10457 6 4 6C2.89543 6 2 6.89543 2 8C2 9.10457 2.89543 10 4 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 14.6667C13.1046 14.6667 14 13.7712 14 12.6667C14 11.5621 13.1046 10.6667 12 10.6667C10.8954 10.6667 10 11.5621 10 12.6667C10 13.7712 10.8954 14.6667 12 14.6667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M5.72656 8.94L10.2799 11.7267" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10.2732 4.27333L5.72656 7.06" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <button 
                  className="refer-earn-copy-button"
                  onClick={handleCopyCode}
                >
                  Copy
                </button>
              </div>
            </div>
            <div className="refer-earn-card-value refer-earn-card-value--code">
              {referralCode}
            </div>
          </div>
        </div>

        <section className="refer-earn-overview">
          <h2 className="refer-earn-section-title">Overview</h2>
          <div className="refer-earn-stats">
            <StatCard value={totalReferrals.toString()} label="Referrals" />
            <StatCard value={successfulReferrals.toString()} label="Successful Referrals" />
          </div>
        </section>

        <section className="refer-earn-referrals">
          <h2 className="refer-earn-section-title">My Referrals</h2>
          
          <div className="refer-earn-search">
            <svg className="refer-earn-search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M19 19L14.65 14.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <input
              type="text"
              className="refer-earn-search-input"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="refer-earn-list">
            {filteredReferrals.map((referral) => (
              <div key={referral.id} className="refer-earn-referral-item">
                <div className="refer-earn-referral-avatar">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="refer-earn-referral-content">
                  <div className="refer-earn-referral-name">{referral.name}</div>
                  <div className="refer-earn-referral-email">{referral.email}</div>
                  <div className="refer-earn-referral-date">{referral.date}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="refer-earn-pagination">
            <button 
              className="refer-earn-pagination-button"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
            >
              Previous
            </button>
            <span className="refer-earn-pagination-info">
              Page {currentPage} of 1
            </span>
            <button 
              className="refer-earn-pagination-button"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(prev => prev + 1)}
            >
              Next
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ProfileReferAndEarn;